/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Civil_Gibbon_GleamInputs */

const en_wild_civil_gibbon_gleam = /** @type {(inputs: Wild_Civil_Gibbon_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memberships`)
};

const de_wild_civil_gibbon_gleam = /** @type {(inputs: Wild_Civil_Gibbon_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "Memberships" |
*
* @param {Wild_Civil_Gibbon_GleamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_civil_gibbon_gleam = /** @type {((inputs?: Wild_Civil_Gibbon_GleamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Civil_Gibbon_GleamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_civil_gibbon_gleam(inputs)
	return de_wild_civil_gibbon_gleam(inputs)
});